import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urlServer } from '../global_constants';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditService {

  token: string | null;
  auditsSubject : Subject<any>;

  pathApiAudits = '/v1/audits';
  urlRequestAudits = urlServer + this.pathApiAudits;

  constructor(private httpClient: HttpClient) {
    this.auditsSubject = new Subject();
    this.token = localStorage.getItem('token') || sessionStorage.getItem('token');
   }


  getAuditsAccount(){
      this.auditsSubject = new Subject();
      const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.token);
      this.httpClient.get(this.urlRequestAudits,{headers}).subscribe((response: any) => {
        this.auditsSubject.next(response);
        this.auditsSubject.complete();
      },error => {
        console.error('Error retrieving list contacts:', error);
      });
    } 
}
